import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles({
  check: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  icon: {
    borderRadius: 4,
    width: 24,
    height: 24,
    backgroundColor: '#F6F6FB',
    border: '1px solid #BCBBD0',

    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },

    'input:hover ~ &': {
      backgroundColor: '#F6F6FB',
    },
  },

  checkedIcon: {
    backgroundColor: '#EB505E',

    '&:before': {
      display: 'block',
      width: 24,
      height: 24,
      backgroundImage:
        "url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiA+PHBhdGggZD0iTTAgNEMwIDEuNzkwODYgMS43OTA4NiAwIDQgMEgyMEMyMi4yMDkxIDAgMjQgMS43OTA4NiAyNCA0VjIwQzI0IDIyLjIwOTEgMjIuMjA5MSAyNCAyMCAyNEg0QzEuNzkwODYgMjQgMCAyMi4yMDkxIDAgMjBWNFoiIGZpbGw9IiNFQjUwNUUiIC8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy42NTQ5IDcuMjQ0MzNDMTguMDcyMyA3LjYwNjAzIDE4LjExNzQgOC4yMzc1OSAxNy43NTU3IDguNjU0OTVMMTAuNTUyMyAxNi45NjY1TDYuMjkyODkgMTIuNzA3MUM1LjkwMjM3IDEyLjMxNjYgNS45MDIzNyAxMS42ODM0IDYuMjkyODkgMTEuMjkyOUM2LjY4MzQyIDEwLjkwMjQgNy4zMTY1OCAxMC45MDI0IDcuNzA3MTEgMTEuMjkyOUwxMC40NDc3IDE0LjAzMzVMMTYuMjQ0MyA3LjM0NTA5QzE2LjYwNiA2LjkyNzczIDE3LjIzNzYgNi44ODI2MiAxNy42NTQ5IDcuMjQ0MzNaIiBmaWxsPSJ3aGl0ZSIgLz48L3N2ZyA+)",
      content: '""',
    },

    'input:hover ~ &': {
      backgroundColor: '#EB505E',
    },
  },
});

export default function CustomizedCheckbox(props) {
  const classes = useStyles();

  return (
    <Checkbox
      checked={props.checked}
      onChange={props.onChange}
      className={classes.check}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      inputProps={{ 'aria-label': 'decorative checkbox' }}
      // {...props}
    />
  );
}
